/*
 * fg-sticky-atc.js
 *
 * Non-invasive shim that retro-fits Horizon's OOTB sticky add-to-cart bar
 * (see sections/product-information.liquid + assets/sticky-add-to-cart.js)
 * with the FG availability system (assets/fg-availability.js).
 *
 * Adds, on the live DOM:
 *   - data-unavailable-disable on <sticky-add-to-cart>
 *   - data-fg-availability-element on the CTA button
 *   - data-fg-oos-text on the button label span
 *   - cloned data-fg-states / data-fg-oos-wh inputs sourced from the main
 *     product-form-component, so the sticky bar acts as its own availability
 *     container.
 *
 * The OOTB sticky JS morphs the bar's inner content on every variant change,
 * which wipes any attributes on descendant elements. The inputs and the
 * data-unavailable-disable attribute on the root <sticky-add-to-cart> survive
 * because morph runs with childrenOnly:true against the inner [ref="stickyBar"].
 * A MutationObserver re-tags the button + label after each morph and then
 * re-runs fgCheckAvailability().
 */
(function () {
  const STATE_INPUT_SELECTOR = 'input[data-fg-states]';
  const WH_INPUT_SELECTOR = 'input[data-fg-oos-wh]';
  const BUTTON_SELECTOR = '.sticky-add-to-cart__button';
  const BUTTON_TEXT_SELECTOR = '.sticky-add-to-cart__button .add-to-cart-text__content > span:first-child';

  function rerunAvailability() {
    if (typeof window.fgCheckAvailability === 'function') {
      window.fgCheckAvailability();
      return;
    }
    document.dispatchEvent(new CustomEvent('fgw_state_change'));
  }

  function ensureSiblingInputs(stickyEl) {
    if (!stickyEl.querySelector(`:scope > ${STATE_INPUT_SELECTOR}`)) {
      const stateInput = document.querySelector(`product-form-component ${STATE_INPUT_SELECTOR}`);
      if (stateInput) stickyEl.appendChild(stateInput.cloneNode(true));
    }
    if (!stickyEl.querySelector(`:scope > ${WH_INPUT_SELECTOR}`)) {
      const whInput = document.querySelector(`product-form-component ${WH_INPUT_SELECTOR}`);
      if (whInput) stickyEl.appendChild(whInput.cloneNode(true));
    }
  }

  function tagButton(stickyEl) {
    const button = stickyEl.querySelector(BUTTON_SELECTOR);
    if (!button || button.hasAttribute('data-fg-availability-element')) return false;

    // Don't hand a Shopify-unavailable (sold-out) button to fg-availability
    if (stickyEl.dataset.variantAvailable !== 'true') return false;

    button.setAttribute('data-fg-availability-element', '');

    const label = stickyEl.querySelector(BUTTON_TEXT_SELECTOR);
    if (label && !label.hasAttribute('data-fg-oos-text')) {
      label.setAttribute('data-fg-oos-text', '');
    }
    return true;
  }

  function bootstrap() {
    const sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;

    sticky.setAttribute('data-unavailable-disable', '');
    ensureSiblingInputs(sticky);
    tagButton(sticky);
    rerunAvailability();

    // Re-tag after Horizon morphs the inner bar on variant updates.
    const stickyBar = sticky.querySelector('[ref="stickyBar"]');
    if (!stickyBar) return;
    new MutationObserver(() => {
      if (tagButton(sticky)) rerunAvailability();
    }).observe(stickyBar, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
